import storageDefaults from 'decorators/storageDefaults';
import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { IWCCStorageManager } from 'managers/iStorage';
import SignalREventsManager from 'managers/signalR/events';
import { EffectsContainer, withEffects } from 'mixins/withEffects';
import { ServicesContext } from 'services/context';
import SimpleTopicsManager from '../discussion/simpleTopics';

const { discussionId } = settings;

interface CommunityTopicsManagerConfig {
    discussionId: string
    searchString: string
    peopleTagsIDs: Array<string>
}

@injectable()
@storageDefaults(<Partial<CommunityTopicsManagerConfig>>{ discussionId, searchString: '', peopleTagsIDs: [] })
export default class CommunityTopicsManager extends SimpleTopicsManager {

    constructor(
        @inject(wccModules.managerConfig) config: CommunityTopicsManagerConfig,
        @inject(wccModules.servicesContext) ctx: ServicesContext,
        @inject(wccModules.storage) storage: IWCCStorageManager,
        @inject(wccModules.signalREvents) signalREvents: SignalREventsManager,
        @inject(wccModules.effects) effects: EffectsContainer
    ) {
        super(config, ctx, storage, signalREvents, effects);
        
    }

    protected override load() {

        // TODO - determine whether this is even needed... 
        // For communityTopicManager, it is only used at the navigation level external to the discussion topic stuff.
        //if (this.searchString.length > 0 || this.peopleTagsIDs.length > 0) {
        //    return this.ctx
        //        .topicsService
        //        .queries
        //        .filteredSimpleTopics(this.discussionId)
        //        .addArgs('$orderby=TopicOrder')
        //        .important()
        //        .toArrayPost({
        //            searchString: this.searchString,
        //            peopleTagsIDs: this.peopleTagsIDs
        //        });
        //}

        return this.ctx
            .topicsService['queries']
            .simpleTopicsByDiscussionIdForCommunity(this.discussionId)
            .addArgs('$orderby=TopicOrder')
            .important()
            .toArray();
    }
}